export type ShipCollateralItemEntity = {
  call_sign: string;
  collateral_item_type_key: 'ship';
  imo_number: string;
  ship_name: string;
  external_url: string;
};
export type VehicleCollateralItemEntity = {
  collateral_item_type_key: 'vehicle';
  vehicle_registration_number: string;
  external_url: string;
};

export function isShipCollateralItem(
  collateralItem: ShipCollateralItemEntity | VehicleCollateralItemEntity,
): collateralItem is ShipCollateralItemEntity {
  return collateralItem.collateral_item_type_key == 'ship';
}
export function isVehicleCollateralItem(
  collateralItem: ShipCollateralItemEntity | VehicleCollateralItemEntity,
): collateralItem is VehicleCollateralItemEntity {
  return collateralItem.collateral_item_type_key == 'vehicle';
}
